module.exports = __webpack_public_path__ + "static/Stage1Back-bd68dfe2166a033829d80a2dcddb5624.png";